import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const Row = styled.span`
  color: ${props => props.color};
  flex: 5 1 0;
  text-align: center;

  svg {
    margin-top: .5rem;
  }
`;

Row.defaultProps = {
  color: colors.darkGrey
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/common/Row.js